import _ from 'lodash';


/*
* Fonction permettant de valider les quantités a recevoir
* return True si les quantités ne sont pas égales à null
*        Faux sinon
*/
const isQuantityToReceiveIsValid = (state) =>{
  let isValid = true;
  _.forEach(state.purchaseReceive.items, item=>{
    if(item.qty_to_receive==null){
      isValid = false;
    }
  })
  return isValid;
}


export default {
  isQuantityToReceiveIsValid
};
